import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateDeviceGroupDocument } from './create.generated';

export const useCreateDeviceGroup = (
  options: ApiOptions<typeof CreateDeviceGroupDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(CreateDeviceGroupDocument, {
    ...useNotifications(CreateDeviceGroupDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.device_groups.create_success'),
    }),
    ...options,
  });
};
